<template>
  <el-main class='main' style="height: calc(100vh - 56px - 20px)">
    <el-input v-model="name" placeholder="请输入名称" style="width: 200px;"></el-input>
    <el-button type="success" @click="query" icon="el-icon-search" style="float: right;background-color: #209323;">查询</el-button>
    <el-button @click="digAdd" icon="el-icon-plus" style="float: right;margin-right: 10px;">添加</el-button>
    <el-table
      :data='tableData'
      style="width: 100%; margin-top: 10px;">
      <el-table-column
        fixed
        prop= 'id'
        label= '编号'
        width= '80'>
      </el-table-column>
      <el-table-column
        prop= 'username'
        label= '用户名'>
      </el-table-column>
      <el-table-column
        prop= 'nickname'
        label= '昵称'
        width= '120'>
      </el-table-column>
      <el-table-column
        prop= 'imageUrl'
        label= '头像'
        width= '100'>
        <template slot-scope='scope'>
          <img :src="apiUrl+'/file/getOneByByte?md5='+scope.row.imageUrl" v-if="scope.row.imageUrl!=null&&scope.row.imageUrl!=''" style="height: 23px;"/>
        </template>
      </el-table-column>
      <el-table-column
        prop= 'status'
        label= '账户状态'
        width= '80'>
        <template slot-scope='scope'>
          <el-button type='success' size='small' v-if="scope.row.status===1">激活</el-button>
          <el-button type='danger' size='small' v-if="scope.row.status===0">冻结</el-button>
        </template>
      </el-table-column>
      <el-table-column
        prop= 'loginTime'
        label= '登入次数'
        width= '80'>
      </el-table-column>
      <el-table-column
        prop= 'loginType'
        label= '注册类型'
        width= '120'>
        <template slot-scope='scope'>
          <el-button type='primary' size='small' v-if="scope.row.loginType===1">平台注册</el-button>
          <el-button type='success' size='small' v-if="scope.row.loginType===2">微信注册</el-button>
          <el-button type='info' size='small' v-if="scope.row.loginType===3">QQ注册</el-button>
          <el-button type='warning' size='small' v-if="scope.row.loginType===4">微博注册</el-button>
          <el-button type='danger' size='small' v-if="scope.row.loginType===5">钉钉注册</el-button>
        </template>
      </el-table-column>
      <el-table-column
        fixed= 'right'
        label= '操作'
        width= '260'>
        <template slot-scope='scope'>
          <el-button @click='frozenUser(scope.row)' type='text' size='small' style="color: #f56c6c" v-if="scope.row.status===1">冻结</el-button>
          <el-button @click='activateUser(scope.row)' type='text' size='small' style="color: #209323" v-if="scope.row.status===0">激活</el-button>
          <el-button @click='bindRolesDig(scope.row)' type='text' size='small' style="color: #209323">绑定角色</el-button>
          <el-button @click='digEdit(scope.row)' type='text' size='small' style="color: #209323">编辑</el-button>
          <el-button @click='digUserInfoEdit(scope.row)' type='text' size='small' style="color: #209323">编辑信息</el-button>
          <el-popover
            :ref="'delRef-'+scope.row.id"
            placement="right"
            width="160"
            trigger="click">
            <p>确定【编号:{{scope.row.id}}】删除吗？</p>
            <div style="text-align: right; margin: 0">
              <el-button size="mini" type="text" @click="delClose(scope.row)">取消</el-button>
              <el-button type="primary" size="mini" style="background-color: #209323;" @click="del(scope.row)">确定</el-button>
            </div>
            <el-button slot="reference" type='text' size='small' style="color: #f56c6c">删除</el-button>
          </el-popover>
        </template>
      </el-table-column>
    </el-table>
    <el-row style="text-align: right;margin-top: 20px;">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="current"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </el-row>
    <el-dialog title="操作表单" :visible.sync="dialogFormVisible">
            <el-form :model="form">
        <el-form-item label="用户名" :label-width="formLabelWidth">
          <el-input v-model="form.username" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="密码" :label-width="formLabelWidth">
          <el-input v-model="form.password" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="昵称" :label-width="formLabelWidth">
          <el-input v-model="form.nickname" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="头像" :label-width="formLabelWidth">
          <el-input v-model="form.imageUrl" autocomplete="off" readonly disabled></el-input>
        </el-form-item>
      </el-form>
      <el-row :style="'padding-left:' + formLabelWidth">
        <el-upload
          class="upload-demo"
          :action="apiUrl + '/file/add/single'"
          :on-success="upLoadSuccess"
          :on-error="upLoadError"
          :file-list="fileList"
          list-type="picture">
          <el-button size="small" type="primary">点击上传</el-button>
        </el-upload>
      </el-row>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm()" style="background-color: #209323;" >确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="编辑用户信息" :visible.sync="dialogFormUserInfoVisible">
      <el-form :model="formUserInfo">
        <el-form-item label="用户ID" :label-width="formLabelWidth">
          <el-input v-model="formUserInfo.userId" autocomplete="off" readonly disabled></el-input>
        </el-form-item>
        <el-form-item label="姓名" :label-width="formLabelWidth">
          <el-input v-model="formUserInfo.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="身份证" :label-width="formLabelWidth">
          <el-input v-model="formUserInfo.idcard" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="手机" :label-width="formLabelWidth">
          <el-input v-model="formUserInfo.phone" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="性别" :label-width="formLabelWidth">
          <el-radio-group v-model="formUserInfo.sex" size="medium">
            <el-radio-button label=1>男</el-radio-button>
            <el-radio-button label=2>女</el-radio-button>
            <el-radio-button label=3>未知</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="邮箱" :label-width="formLabelWidth">
          <el-input v-model="formUserInfo.email" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="标签" :label-width="formLabelWidth">
          <el-input v-model="formUserInfo.labels" autocomplete="off" placeholder="英文','逗号分隔" readonly disabled></el-input>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer" v-if="config.syncPersonEnabel===false">
        <el-button @click="dialogFormUserInfoVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitUserInfoForm()" style="background-color: #209323;" >确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="账户绑定角色" :visible.sync="dialogBindVisible">
      <el-tree
        ref="tree"
        :data="roles"
        show-checkbox
        node-key="id"
        :default-expanded-keys="bindRoles"
        :default-checked-keys="bindRoles"
        :props="defaultProps">
      </el-tree>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogBindVisible = false">取 消</el-button>
        <el-button type="primary" @click="bindSubmitRoles()" style="background-color: #209323;" >确 定</el-button>
      </div>
    </el-dialog>
  </el-main>
</template>
<script>
import requestService from '../../../util/request'
export default {
  data () {
    return {
      tableData: [],
      name: '',
      apiUrl: '',
      dialogFormVisible: false,
      dialogBindVisible: false,
      form: {
        id: null,
        addTime: null,
        upTime: null,
        username: null,
        password: null,
        loginType: null,
        nickname: null,
        uuid: null,
        organizationId: null,
        imageUrl: null,
        departmentId: null,
        status: null,
        loginTime: null
      },
      dialogFormUserInfoVisible: false,
      formUserInfo: {
        id: null,
        addTime: null,
        upTime: null,
        userId: null,
        name: null,
        idcard: null,
        phone: null,
        sex: null,
        email: null,
        labels: null
      },
      curRole: {},
      roles: [],
      bindRoles: [],
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      formLabelWidth: '120px',
      current: 1,
      pageSize: 10,
      total: 0,
      pages: 0,
      organizationId: 0,
      fileList: [],
      config: {}
    }
  },
  created () {
    this.query()
    this.queryRole()
    this.initData()
    this.config = JSON.parse(localStorage.getItem('appConfig') + '')
    this.apiUrl = this.$global.apiUrl
  },
  methods: {
    upLoadSuccess (res) {
      // console.log(res)
      // {name:'', url:''}
      this.fileList = []
      this.fileList.push({name: res.data.body.name, url: `${this.apiUrl}/file/getOneByByte?md5=${res.data.body.md5}`})
      this.form.imageUrl = res.data.body.md5
    },
    upLoadError () {
      this.fileList = []
    },
    del (row) {
      let that = this
      console.log('del')
      document.body.click()
      let params = {
        id: row.id
      }
      requestService.post('/user/del', params, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then((res) => {
        that.query()
      })
    },
    delClose (row) {
      document.body.click()
    },
    initData () {
      let userInfo = JSON.parse(localStorage.getItem('userInfo') + '')
      if (!userInfo || !userInfo.organizationId) {
        return
      }
      this.organizationId = userInfo.organizationId
    },
    query () {
      let that = this
      requestService.get(`/user/system/manage/listPage?current=${that.current}&pageSize=${that.pageSize}&name=${that.name}`, {
      }, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then((res) => {
        that.tableData = res.data.body.records
        that.total = res.data.body.total
        that.pages = res.data.body.pages
      })
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.query()
    },
    handleCurrentChange (val) {
      this.current = val
      this.query()
    },
    digEdit (row = {}) {
      this.form = {...row}
      this.dialogFormVisible = true
      this.fileList = []
      if (this.form.imageUrl) {
        this.fileList.push({name: this.form.username, url: `${this.apiUrl}/file/getOneByByte?md5=${this.form.imageUrl}`})
      }
    },
    digAdd () {
      this.fileList = []
      this.form = {}
      this.dialogFormVisible = true
    },
    submitForm () {
      let that = this
      that.dialogFormVisible = false
      console.log('add')
      let url = '/user/system/add'
      if (that.form.id) {
        url = '/user/system/edit'
      }
      that.form.organizationId = that.organizationId
      requestService.post(url, that.form, {headers: {'Content-Type': 'application/json'}}).then((res) => {
        that.query()
      })
    },
    queryRole () {
      let that = this
      requestService.get('/role/list', {
      }, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then((res) => {
        that.roles = res.data.body
      })
    },
    bindRolesDig (row) {
      let that = this
      that.curRole = {...row}
      requestService.get(`/role/getUserRoleList?userId=${row.id}`, {
      }, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then((res) => {
        that.bindRoles = []
        for (let temp of res.data.body) {
          that.bindRoles.push(temp.id)
        }
        that.$nextTick(() => {
          that.$refs.tree.setCheckedKeys(that.bindRoles)
        })
        that.dialogBindVisible = true
      })
    },
    bindSubmitRoles () {
      // console.log(this.$refs.tree.getCheckedNodes())
      // console.log(this.$refs.tree.getCheckedKeys())
      let that = this
      that.dialogBindVisible = false
      console.log(that.submitBindPermisses)
      let roleIdsStr = ''
      for (let index in this.$refs.tree.getCheckedKeys()) {
        if (index < this.$refs.tree.getCheckedKeys().length - 1) {
          roleIdsStr = roleIdsStr + this.$refs.tree.getCheckedKeys()[index] + ','
        } else {
          roleIdsStr = roleIdsStr + this.$refs.tree.getCheckedKeys()[index]
        }
      }
      requestService.post('/user/bindRoles', {userId: that.curRole.id, roleIds: roleIdsStr}, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then((res) => {
        that.query()
      })
    },
    activateUser (row = {}) {
      let that = this
      requestService.post('/user/activateUser', {id: row.id}, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then((res) => {
        that.query()
      })
    },
    frozenUser (row = {}) {
      let that = this
      requestService.post('/user/frozenUser', {id: row.id}, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then((res) => {
        that.query()
      })
    },
    digUserInfoEdit (row = {}) {
      this.form = {...row}
      this.dialogFormUserInfoVisible = true
      let that = this
      that.formUserInfo = {}
      requestService.post('/userInfo/getOneByUserId', {userId: row.id}, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then((res) => {
        that.formUserInfo = {...res.data.body}
        that.formUserInfo.userId = row.id
      })
    },
    submitUserInfoForm () {
      let that = this
      that.dialogFormUserInfoVisible = false
      requestService.post('/userInfo/editByUserId', that.formUserInfo, {headers: {'Content-Type': 'application/json'}}).then((res) => {
        that.query()
      })
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/manage-components/user/Index.vue